import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import { StringUtils, ArrayUtils } from '../../utils';
import { Routes as routes } from '../../navigation';
import { UserActions, NavigationActions, ContextActions, PracticeActions, ToastActions } from '../../actions';
import { SwitchAccount, TitleBar, NavBar, SingleScreenNavBar, Button, Header, Line } from  '../../components'

class PracticeStaffMemberDetailsScreen extends Component {

  constructor(props) {
    super(props);
    this.state = {
      selected_member_details: {},
      selected_member_locations: [],
      selected_member_roles: {},
      currentRoles: null,
      currentLocations: null,
      member_user_id: '',
      noRoleSelected: false,
      noLocationSelected: false,
      locationRequestsCount: 0,
      locationRequestsCompleted: 0,
      displayEditRoles: false,
      displayEditLocations: false,
    }
  }

  retrieveStaffDetails = () => {
    let token       = this.props.user && this.props.user.auth && this.props.user.auth.token ? this.props.user.auth.token : '';
    let props       = this.props.location.state.props;
    let user_id     = props && props.user_id     ? props.user_id     : '';
    let practice_id = props && props.practice_id ? props.practice_id : '';

    if (token && user_id) {
      this.props.practiceActions.getStaffMemberDetails(token, user_id, practice_id, this.setStaffMemberDetails);
      this.setState({ ...this.state, member_user_id: user_id });
    }
  }

  componentDidMount() {
    this.retrieveStaffDetails();
  }

  renderStaffMemberDetails = (member, roles, locations) => {
    if (!member) {
      return null;
    }

    let member_name   = member && StringUtils.displayName(member) ? StringUtils.displayName(member) : 'Staff Details';
    let is_front_desk = roles && roles.front_desk ? true : false;

    return <div className="flex-container screen-main-content">
      <div className="screen-container-column">
        <div className="standard-container">
          <Header title={member_name} icon='fas fa-id-card' />

          <div className='flex-container-column' style={{ padding: 15 }}>
            <div className="flex-container flex-container-row">
              <div>
                { member.photo_url ? <img className="image-default" style={{ height: 40, width: 40, borderRadius: 20 }} src={member.photo_url} />
                  : <span className="fas fa-user-circle" style={{ fontSize: 40, color: '#e9e9e9' }}></span> }
              </div>
              <div className="flex-container flex-container-column flex-center-justify" style={{ marginLeft: 15 }}>
                <span style={{ fontSize: 13, color: 'grey' }}>{ StringUtils.displayName(member) }</span>
                <span style={{ fontSize: 13, color: 'grey', marginTop: -3 }}>{ member.email }</span>
              </div>
            </div>

            <Line style={{ marginTop: 15 }} />

            { this.state.displayEditRoles ? this.renderEditRoles(roles) : this.renderStaffRoles(roles) }
            <div style={{ height: 1, width: '100%', backgroundColor: '#e7e7e7', marginTop: 15, marginBottom: 5 }}></div>
            { this.state.displayEditLocations ? this.renderEditLocations(locations) : this.renderStaffLocations(locations, is_front_desk) }

          </div>

        </div>
      </div>
    </div>
  }

  renderEditRoles = (roles) => {

    let currentRoles = this.state.currentRoles;
    let currentPractice = this.props.practice && this.props.practice.info ? this.props.practice.info : {};

    var roleOptions = [];

    roleOptions.push({ label: 'Admin',            role: 'admin'            });
    roleOptions.push( currentPractice.type === "MEDICAL" ? { label: 'Veterinarian', role: 'vet' } : { label: 'Behaviorist', role: 'behaviorist' });
    roleOptions.push({ label: 'Practice Manager', role: 'practice_manager' });
    roleOptions.push({ label: 'Practice Owner',   role: 'practice_owner'   });
    roleOptions.push({ label: 'Tech',             role: 'tech'             });

    const roleRow = roleOptions.map((role) => {
      const rolesToCheck = this.state.currentRoles ? this.state.currentRoles : roles;
      const selected = rolesToCheck[role.role] === true ? true : false;
      return <input key={role.role}
                    className={`button-clear-blue ${ selected ? 'button-clear-selected' : '' }`}
                    style={{ margin: 5, fontSize: 13 }}
                    value={role.label}
                    type="submit"
                    onClick={ () => {
                      let currentlySelected = this.state.currentRoles;
                      currentlySelected[role.role] = !currentlySelected[role.role];
                      let atLeastOneSelected = this.checkRoleSelected(currentlySelected);
                      this.setState({
                        ...this.state,
                        currentRoles: currentlySelected,
                        noRoleSelected: !atLeastOneSelected,
                      })
                    }}
                  />
    })

    return <div className="flex-container-column" style={{ marginTop: 15 }}>
      <span style={{ fontSize: 13, color: '#474747', marginBottom: 10 }}>Roles - Edit User Roles at this Practice</span>
      <div className='flex-container-row' style={{ justifyContent: 'center' }}>
        { roleRow }
      </div>
      <div className='flex-container-row' style={{ marginTop: 10, justifyContent: 'flex-end' }}>
        <input  type="submit"
                value="Cancel"
                className="button-clear-blue"
                style={{ marginBottom: 10, fontSize: 13 }}
                onClick={ () => {
                  this.setState({
                    ...this.state,
                    displayEditRoles: false,
                    displayEditLocations: false,
                    currentRoles: Object.assign({}, roles),
                  })
                }}
              />
        <Button value="Save Roles"
                disabled={this.state.noRoleSelected}
                style={{ marginLeft: 5, marginBottom: 10, fontSize: 13, backgroundColor: this.state.noRoleSelected ? 'grey' : '#1dc2ff' }}
                onClick={ () => {
                  let selectedRoles = Object.assign({}, this.state.currentRoles);
                  let token         = this.props.user && this.props.user.auth && this.props.user.auth.token ? this.props.user.auth.token : '';
                  let roles_id      = roles._id;

                  if (token && roles_id && selectedRoles.practice_id) {
                    selectedRoles.user_id = this.state.member_user_id;
                    selectedRoles._id = roles_id;
                    this.props.practiceActions.updatePracticeUserRole(token, selectedRoles, this.successCallback)
                  }
                }}
              />
      </div>
    </div>
  }

  renderStaffRoles = (roles) => {
    if (!roles) {
      return null;
    }

    var allRolesText = '';
    var allRoles = [];

    allRoles.push(roles.admin ? 'Admin' : '');
    allRoles.push(roles.practice_manager ?  'Practice Manager' : '');
    allRoles.push(roles.practice_owner ?  'Practice Owner' : '');
    allRoles.push(roles.vet ?  'Veterinarian' : '');
    allRoles.push(roles.behaviorist ?  'Behaviorist' : '');
    allRoles.push(roles.tech ? 'Tech' : '');
    allRoles.push(roles.front_desk ? 'Front Desk' : '');

    allRoles.forEach((roleText) => {
      if (allRolesText === '' && roleText !== '') {
        allRolesText = roleText;
      } else if (roleText !== '') {
        allRolesText = allRolesText + ' | ' + roleText;
      }
    })

    return <div className='flex-container-row' style={{ justifyContent: 'space-between', alignItems: 'center', marginTop: 15 }}>
      <div className="flex-container flex-container-column">
        <span style={{ color: '#575757', fontSize: 13 }}>Roles</span>
        <span style={{ color: 'grey', fontSize: 13, marginTop: -3 }}>{ allRolesText }</span>
      </div>
      { roles.front_desk ? null : <div>
        <Button value='Edit'
                className='button-clear-blue'
                style={{ fontSize: 13, color: '#1dc2ff' }}
                onClick={ () => {
                  this.setState({
                    ...this.state,
                    currentRoles: Object.assign({}, roles),
                    displayEditRoles: true,
                    displayEditLocations: false
                  });
                }}
              />
      </div> }
    </div>
  }

  renderEditLocations = (locations) => {
    let all_locations    = this.props.practice && this.props.practice.locations ? this.props.practice.locations : {};
    let locations_ids    = Object.keys(all_locations);
    let member_locations = locations || [];
    let member_locations_dict = {};
    let currentlySelected = this.state.currentLocations || {};

    member_locations.forEach((loc) => {
      let location_details = loc;
      let location_id      = location_details._id;
      member_locations_dict[location_id] = loc;
    });

    let location_rows = locations_ids.map((location_id) => {
      let location_details  = all_locations[location_id];
      let this_one_selected = currentlySelected[location_id] && currentlySelected[location_id].selected ? true : false;
      if (location_details) {
        return <div key={location_id}
                    className={ `flex-container-column button-clear-blue ${ this_one_selected ? 'button-clear-selected' : '' }` }
                    style={{ marginBottom: 10, fontWeight: 'normal' }}
                    onClick={ () => {
                      if (currentlySelected[location_id]) {
                        currentlySelected[location_id].selected = !currentlySelected[location_id].selected;
                        let no_location_selected = !this.checkLocationSelected(currentlySelected)
                        this.setState({ ...this.state, currentLocations: Object.assign({}, currentlySelected), noLocationSelected: no_location_selected });
                      } else {
                        let location_to_add = Object.assign({}, location_details);
                        location_to_add.selected = true;
                        currentlySelected[location_id] = location_to_add;
                        let no_location_selected = !this.checkLocationSelected(currentlySelected)
                        this.setState({ ...this.state, currentLocations: Object.assign({}, currentlySelected), noLocationSelected: no_location_selected });
                      }
                    }}>
          <span style={{ fontSize: 13, color: '#1dc2ff' }}>{ location_details.name }</span>
          <span style={{ fontSize: 13, color: 'grey' }}>{ location_details.street_address }</span>
          <span style={{ fontSize: 13, color: 'grey' }}>{ location_details.city + ' ' + location_details.state }</span>
        </div>
      }
    }).filter((row) => { return row });

    return <div className='flex-container-column' style={{ marginTop: 15 }}>
      <span style={{ marginBottom: 5, color: '#575757', fontSize: 13 }}>Provider Locations</span>
      { location_rows }
      <div className='flex-container-row' style={{ marginTop: 10, justifyContent: 'center' }}>
        <input  type="submit"
                value="Cancel"
                className="button-clear"
                style={{ marginBottom: 10 }}
                onClick={ () => {
                  this.setState({
                    ...this.state,
                    displayEditRoles: false,
                    displayEditLocations: false,
                  })
                }}
              />
        <Button value="Save User Locations"
                disabled={this.state.noLocationSelected}
                style={{ marginLeft: 5, marginBottom: 10, backgroundColor: this.state.noLocationSelected ? 'grey' : '#1dc2ff' }}
                onClick={ () => {
                  let final_selection = Object.assign({}, this.state.currentLocations);
                  let location_ids    = Object.keys(final_selection);
                  let member_user_id  = this.state.member_user_id;
                  let current_practice_id = this.props.practice && this.props.practice.info && this.props.practice.info._id ? this.props.practice.info._id : '';
                  let token = this.props.user && this.props.user.auth && this.props.user.auth.token ? this.props.user.auth.token : '';

                  location_ids.forEach((loc_id) => {
                    let selected_loc = final_selection[loc_id];
                    if (selected_loc.selected === true && member_locations_dict[loc_id]) {
                      // Keep as is
                    }
                    if (selected_loc.selected === false && member_locations_dict[loc_id]) {
                      let user_id = member_user_id;
                      this.props.userActions.deleteUserPracticeLocation(token, user_id, loc_id, this.locationSuccessCallback);
                      this.setState({ ...this.state, locationRequestsCount: this.state.locationRequestsCount + 1 });
                    }
                    if (selected_loc.selected === true && !member_locations_dict[loc_id]) {
                      let user_location_object = {
                        user_id: member_user_id,
                        practice_id: current_practice_id,
                        practice_location_id: loc_id,
                      }

                      this.props.userActions.addUserPracticeLocation(token, user_location_object, this.locationSuccessCallback);
                      this.setState({ ...this.state, locationRequestsCount: this.state.locationRequestsCount + 1 });
                    }
                  })

                }}
              />
      </div>
    </div>
  }

  renderStaffLocations = (locations, is_front_desk) => {

    let member_locations = locations || [];

    let member_location_rows = member_locations.map((member_loc, index) => {
      let location_details = member_loc;
      if (location_details) {
        return <div className={`flex-container flex-container-column`} key={member_loc._id} style={{ marginTop: index === 0 ? 0 : 10 }}>
          <span style={{ fontSize: 13, color: 'grey' }}>{ location_details.name }</span>
          <span style={{ fontSize: 13, color: 'grey' }}>{ location_details.street_address }</span>
          <span style={{ fontSize: 13, color: 'grey' }}>{ location_details.city + ' ' + location_details.state }</span>
        </div>
      }
    }).filter((row) => { return row });

    return <div className='flex-container-row' style={{ justifyContent: 'space-between', alignItems: 'flex-start', marginTop: 15 }}>
      <div className="flex-container flex-container-column">
        <span style={{ fontSize: 13, color: '#575757', marginBottom: 5 }}>Provider Locations</span>
        { member_location_rows }
      </div>
      { is_front_desk ? null : <div>
        <Button value='Edit'
                className='button-clear-blue'
                style={{ fontSize: 13, color: '#1dc2ff' }}
                onClick={ () => {
                  let currentlySelected = {};
                  let current_practice_id = this.props.practice && this.props.practice.info && this.props.practice.info._id ? this.props.practice.info._id : '';
                  locations.forEach((location) => {
                    let locationObject = Object.assign({}, location);
                    if (current_practice_id && locationObject.practice_id === current_practice_id) {
                      locationObject.selected = true
                      currentlySelected[location._id] = locationObject;
                    }
                  });
                  this.setState({
                    ...this.state,
                    currentLocations: Object.assign({}, currentlySelected),
                    displayEditRoles: false,
                    displayEditLocations: true
                  })
                }}
              />
      </div> }
    </div>
  }

  render() {

    let selected_member_details   = this.state.selected_member_details;
    let selected_member_locations = this.state.selected_member_locations;
    let selected_member_roles     = this.state.selected_member_roles;

    return (
      <div className="flex-container flex-container-column flex-center-align">
        <TitleBar
          selectedPractice={this.props.context.selectedPractice}
          selectedRole={this.props.context.selectedRole}
          practices={this.props.user.practices}
          userActions={this.props.userActions}
          practice={this.props.practice.practice}
        />
        <SingleScreenNavBar title="Staff Member Details" />
        { this.renderStaffMemberDetails(selected_member_details, selected_member_roles, selected_member_locations) }
      </div>
    );
  }

  checkRoleSelected = (roles) => {
    let keys = Object.keys(roles);
    let atLeastOneSelected = false;
    keys.forEach((key) => {
      if ((key === 'admin' || key === 'behaviorist' || key === 'vet' || key === 'tech' || key === 'practice_manager'  || key === 'practice_owner') && roles[key] === true) {
        atLeastOneSelected = true;
      }
    });
    return atLeastOneSelected;
  }

  checkLocationSelected = (locations) => {
    let keys = Object.keys(locations);
    let atLeastOneSelected = false;
    keys.forEach((key) => {
      if (locations[key] && locations[key].selected === true) {
        atLeastOneSelected = true;
      }
    });
    return atLeastOneSelected;
  }

  successCallback = () => {
    this.retrieveStaffDetails();
    this.setState({
      ...this.state,
      currentRoles: null,
      currentLocations: null,
      noRoleSelected: false,
      displayEditRoles: false,
      displayEditLocations: false,
    })
  }

  locationSuccessCallback = () => {

    let total_requests_count    = this.state.locationRequestsCount;
    let current_completed_count = this.state.locationRequestsCompleted;
    let new_completed_count     = current_completed_count + 1;

    if (new_completed_count === total_requests_count) {
      this.props.toastActions.displayInfo('Saved Location Changes!')
    }
    this.retrieveStaffDetails();

    this.setState({
      ...this.state,
      currentRoles: null,
      currentLocations: null,
      noRoleSelected: false,
      displayEditRoles: false,
      displayEditLocations: false,
      locationRequestsCompleted: new_completed_count,
    })
  }

  setStaffMemberDetails = (data) => {
    if (data && data.success) {
      let practice_user_locations = data.user_practice_locations;
      let roles     = ArrayUtils.getSingleObject(data.user_roles);
      let details   = data.user;

      let location_details = practice_user_locations.map((user_location) => {
        let location = ArrayUtils.getSingleObject(user_location.practice_location);
        if (location) {
          return location;
        }
      }).filter((loc) => { return loc });

      this.setState({
        ...this.state,
        selected_member_locations: location_details,
        selected_member_details: details,
        selected_member_roles: roles,
      })
    }
  }

}

const mapStateToProps = (state) => {
  return {
    user: state.user,
    context: state.context,
    practice: state.practice,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    contextActions: bindActionCreators(
     { ...ContextActions }, dispatch),
    practiceActions: bindActionCreators(
     { ...PracticeActions }, dispatch),
    toastActions: bindActionCreators(
     { ...ToastActions }, dispatch),
    userActions: bindActionCreators(
     { ...UserActions }, dispatch)
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(PracticeStaffMemberDetailsScreen)
